import { AppSidebar } from "@/components/sidebar/app-sidebar"
import { Separator } from "@/components/ui/separator"
import {
  SidebarInset,
  SidebarProvider,
  SidebarTrigger,
} from "@/components/ui/sidebar"
import { MrrCard } from "@/components/dashboard/mrr-card"
import { UsersStatCard } from "@/components/dashboard/users-stat-card"
import { PluginsStatCard } from "@/components/dashboard/plugins-stat-card"
import { CandidatesStatCard } from "@/components/dashboard/candidates-stat-card"
import { CompaniesStatCard } from "@/components/dashboard/companies-stat-card"
import { SchoolsStatCard } from "@/components/dashboard/schools-stat-card"
import { QueueSummaryCard } from "@/components/dashboard/queue-summary-card"
import { SubscriptionPieCard } from "@/components/dashboard/subscription-pie-card"
import { RevenueBarCard } from "@/components/dashboard/revenue-bar-card"
import { RecentUsersCard } from "@/components/dashboard/recent-users-card"
import { B2bStatsSection } from "@/components/dashboard/b2b-stats-section"

export default function DashboardPage() {
  return (
    <SidebarProvider>
      <AppSidebar />
      <SidebarInset>
        <header className="flex h-16 shrink-0 items-center gap-2 transition-[width,height] ease-linear group-has-[[data-collapsible=icon]]/sidebar-wrapper:h-12">
          <div className="flex items-center gap-2 px-4">
            <SidebarTrigger className="-ml-1" />
            <Separator orientation="vertical" className="mr-2 h-4" />
            <h1 className="text-sm font-medium">Dashboard</h1>
          </div>
        </header>

        <div className="flex flex-1 flex-col gap-6 p-4 pt-0">
          {/* KPI Strip */}
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
            <MrrCard />
            <UsersStatCard />
            <PluginsStatCard />
            <CandidatesStatCard />
            <CompaniesStatCard />
            <SchoolsStatCard />
          </div>

          {/* Operations + Subscription distribution */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
            <QueueSummaryCard />
            <SubscriptionPieCard />
          </div>

          {/* Revenue breakdown */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
            <RevenueBarCard />
          </div>

          {/* Comptes entreprise (B2B) */}
          <B2bStatsSection />

          {/* Recent users */}
          <RecentUsersCard />
        </div>
      </SidebarInset>
    </SidebarProvider>
  )
}
